import { FilterChip } from './FilterChip';
import { FilterChipsRoot } from './FilterChipsRoot';

export const FilterChips = {
  Root: FilterChipsRoot,
  Chip: FilterChip,
};
